import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function GamesView() {

    return (
        <div className="contentCol">
            {/* Headline */}
            <h1>Hvad har du lyst til at træne idag?</h1>

            {/* Games view */}
            <div className="card">
                {/* Games section */}
                <div className="contentCol">
                    {/* Game 1 */}
                    <div className="gameCardWide">
                        <div className="contentRow">
                            <div className="contentCol">
                                <img
                                    src="/images/ligningsmester.png"
                                    alt="Ligningsmester"
                                    className="h-32 w-32 rounded-lg mb-4"
                                />

                                <h2>Ligningsmesteren</h2>

                                <p>Det originale ligningsspil med tre niveauer. Her lærer du at løse ligninger startene helt fra bunden. Til sidst vil du komme til at mestre ligninger i tre skridt, og nemt håndtere både parenteser, brøker, og variabler på begge sider af lighedstegnet. </p>
                            </div>

                            <Link to="/Drills/ligningsmester">
                                <button className="buttonSubmit">åben</button>
                            </Link>
                        </div>
                    </div>
                    {/* Game 2 */}
                    <div className="gameCardWide">
                        <div className="contentRow">
                            <div className="contentCol">
                                <img
                                    src="/images/formelknuseren.png"
                                    alt="formelknuseren"
                                    className="h-32 w-32 rounded-lg mb-4"
                                />

                                <h2>Formelknuseren</h2>

                                <p>Kommende spil om brug af formel.</p>
                            </div>

                            <Link to="/Drills/ligningsmester">
                            <button className="buttonSubmit">åben</button>
                            </Link>

                            {/* overlay */}
                            <div className="overlay">
                                <span>Kommer snart</span>
                            </div>
                        </div>
                    </div>
                    
                    {/* Game 3 */}
                    <div className="gameCardWide">
                        <div className="contentRow">
                            <div className="contentCol">
                                <img
                                    src="/images/trigonometeren.png"
                                    alt="trigonometeren"
                                    className="h-32 w-32 rounded-lg mb-4"
                                />

                                <h2>Trigonometeren</h2>

                                <p>Kommende spil om trekanter.</p>
                            </div>

                            <Link to="/Drills/ligningsmester">
                                <button className="buttonSubmit">åben</button>
                            </Link>

                            {/* overlay */}
                            <div className="overlay">
                                <span>Kommer snart</span>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    )
}